const banks = {
  "SBERBANK": "Сбербанк",
  "VTB24": "Банк ВТБ24",
  "TINKOFF CREDIT SYSTEMS": "Тинькофф Банк",
  "ALFA-BANK": "Альфа-Банк",
  "GAZPROMBANK": "Газпромбанк",
  "RAIFFEISENBANK": "Райффайзенбанк",
  "JYSAN BANK": "JYSAN KZ",
  "KASPI BANK": "KASPI KZ",
  "HALYK BANK": "HALYK KZ",
  "BANK OF MOSCOW": "Банк Москвы",
  "CITIBANK": "Ситибанк",
  "PROMSVYAZBANK": "Промсвязьбанк",
  "URALSIB": "Банк УРАЛСИБ",
  "ROSBANK": "Росбанк",
  "CREDIT UNION PAYMENT CENTER (RNKO)": "РНКО Платежный Центр",
  "WEST-SIBERIAN COMMERCIAL BANK": "Запсибкомбанк",
  "RUSSIAN STANDARD BANK": "Банк Русский Стандарт",
  "UNICREDIT BANK": "ЮниКредит Банк",
  "QIWI BANK": "QIWI Банк",
  "OTKRITIE": "Открытие",
  "AVANGARD": "Авангард",
  "CREDIT BANK OF MOSCOW": "Московский кредитный банк",
  "PRIVATBANK": "Приватбанк",
  "VTB": "Банк ВТБ",
  "CREDIT EUROPE BANK": "Кредит Европа банк",
  "BANK SAINT-PETERSBURG": "Банк Санкт-Петербург",
  "MTS-BANK": "МТС Банк",
  "HOME CREDIT": "Банк Хоум Кредит",
  "UBRIR": "УБРиР",
  "BANK VOZROZHDENIE": "Банк Возрождение",
  "MDM BANK": "МДМ-банк",
  "MOSCOMPRIVATBANK": "МоскомПриватБанк",
  "MOSCOW INDUSTRIAL BANK": "Московский Индустриальный банк",
  "RUSSIAN REGIONAL DEVELOPMENT BANK": "ВБРР",
  "ROSSELKHOZBANK": "Россельхозбанк",
  "ROSEVROBANK": "Росевробанк",
  "OTP BANK": "ОТП Банк",
  "COMMERCIAL BANK PETROCOMMERCE": "Банк Петрокоммерц",
  "SURGUTNEFTEGASBANK": "Сургутнефтегазбанк",
  "ROSGOSSTRAKH BANK": "Росгосстрах банк",
  "PRIORBANK": "Приорбанк",
  "MOSKOMMERTSBANK": "Москоммерцбанк",
  "ROSDORBANK": "Росдорбанк",
  "DOM.RF": "Дом.рф",
  "AK BARS": "Ак Барс Банк",
  "CHELYABINVEST": "Челябинвестбанк",
  "LEVOBEREZHNY": "Левобережный",
  "SIAB": "Банк СИАБ",
  "BANK CENTERCREDIT": "BANK CENTERCREDIT",
  "BEREKE": "BEREKE",
  "KAZPOST": "KAZPOST"
}

export default banks
